// removed by extract-text-webpack-plugin
module.exports = {"product-des-input":"product-des-input"};


//////////////////
// WEBPACK FOOTER
// ./components/my-business/profile/_business-content-section.scss
// module id = ./components/my-business/profile/_business-content-section.scss
// module chunks = 0